import React from 'react';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router';
import { useOnMount } from '@chaser/components';
import LoadingMessage from '../../components/LoadingMessage';
import AuthenticationService from '../../services/authentication-service';
import usePush from '../../hooks/usePush';

const LoginIntuit = () => {
  const { isLoggedIn, features } = useSelector(state => state.loginReducer);
  const { execute } = usePush(AuthenticationService.loginIntuit);
  const history = useHistory();

  async function loginIntuit() {
    const [err, res] = await execute();

    if (err) {
      history.push('/login', { loginError: 'Sorry unable to authenticate using Intuit.' });
      return;
    }

    const { url } = res;
    window.location.replace(url);
  }

  useOnMount(() => {
    const shouldStay = isLoggedIn && features?.intuitAuthMerged;
    if (shouldStay) {
      history.replace('/');
    } else {
      loginIntuit();
    }
  });

  return <LoadingMessage center useLogoAnimation />;
};

export default LoginIntuit;
